<template>
  <div
    v-if="item?.participant_filters"
    class="pb-15"
  >
    <v-row
      align="center"
      class="px-4 my-0 mt-2"
    >
      <div class="text-h6 mr-3">Выборка пользователей</div>
      <!--      <v-tooltip bottom>-->
      <!--        <template v-slot:activator="{ on }">-->
      <!--          <v-icon-->
      <!--            color="warning"-->
      <!--            class="mr-3"-->
      <!--            v-on="on"-->
      <!--            >mdi-alert</v-icon-->
      <!--          >-->
      <!--        </template>-->
      <!--        <span></span>-->
      <!--      </v-tooltip>-->
      <v-divider />
    </v-row>
    <v-select
      class="rounded-lg mt-4"
      dense
      label="Пол"
      :items="$user.sexItems"
      v-model="item.participant_filters.sex"
      item-value="value"
      item-text="title"
      outlined
      :disabled="isDisabled"
      :clearable="!isDisabled"
    ></v-select>
    <v-row
      no-gutters
      style="gap: 10px"
      class="mt-4"
    >
      <v-text-field
        class="rounded-lg"
        dense
        label="Возраст 'с'"
        v-model.number="item.participant_filters.start_age"
        outlined
        type="number"
        :rules="!item.id ? [v => !v || v >= 0 || 'Возраст не может быть отрицательным'] : []"
        min="0"
        ref="kekRef"
        :disabled="isDisabled"
        :clearable="!isDisabled"
      ></v-text-field>
      <v-text-field
        v-model.number="item.participant_filters.end_age"
        class="rounded-lg"
        dense
        label="Возраст 'по'"
        outlined
        type="number"
        :rules="!item.id ? [v => !v || v >= 0 || 'Возраст не может быть отрицательным'] : []"
        min="0"
        :disabled="isDisabled"
        :clearable="!isDisabled"
      ></v-text-field>
    </v-row>
    <v-row
      no-gutters
      align="center"
      class="mt-4"
    >
      <v-text-field
        v-if="!isPhoneInputReadOnly"
        v-model="rawPhones"
        class="rounded-lg"
        dense
        label="Номера телефонов"
        outlined
        @blur="onPhoneInputBlur"
        :disabled="isDisabled"
        hide-details
      ></v-text-field>
      <v-col
        @click="!isDisabled && (manyPhonesInputModalModelValue = true)"
        v-else
      >
        <v-text-field
          :value="formattedSelectedPhones"
          class="rounded-lg"
          style="width: 100%"
          dense
          label="Номера телефонов"
          outlined
          readonly
          hide-details
          :disabled="isDisabled"
        ></v-text-field>
      </v-col>
      <v-btn
        depressed
        color="primary"
        class="ml-3"
        @click="manyPhonesInputModalModelValue = true"
        :disabled="isDisabled"
      >
        <div class="text-none">Указать несколько</div>
      </v-btn>
    </v-row>

    <v-row
      no-gutters
      style="gap: 10px"
      class="mt-4"
    >
      <DatePicker
        ref="startActivityPeriodRef"
        v-model="item.participant_filters.start_activity_period"
        @input="onActivityPeriodInput"
        class="rounded-lg"
        dense
        label="Начало периода активности"
        outlined
        :rules="
          !item.id
            ? [rules.required, () => activityPeriodValid || 'Проверьте период активности']
            : []
        "
        :hide-details="false"
        :disabled="isDisabled"
      />
      <DatePicker
        ref="endActivityPeriodRef"
        v-model="item.participant_filters.end_activity_period"
        @input="onActivityPeriodInput"
        class="rounded-lg"
        dense
        label="Конец периода активности"
        outlined
        :rules="
          !item.id
            ? [rules.required, () => activityPeriodValid || 'Проверьте период активности']
            : []
        "
        :hide-details="false"
        :disabled="isDisabled"
      />
    </v-row>
    <v-row
      no-gutters
      style="gap: 10px"
      class="mt-4"
    >
      <DatePicker
        ref="startActivityPeriodRef"
        v-model="item.participant_filters.start_registered_at"
        class="rounded-lg"
        dense
        label="Начало периода регистрации"
        outlined
        :hide-details="true"
        :disabled="isDisabled"
        :clearable="!isDisabled"
      />
      <DatePicker
        ref="startActivityPeriodRef"
        v-model="item.participant_filters.end_registered_at"
        class="rounded-lg"
        dense
        label="Конец периода регистрации"
        outlined
        :hide-details="true"
        :disabled="isDisabled"
        :clearable="!isDisabled"
      />
    </v-row>
    <v-row
      no-gutters
      style="gap: 10px"
      class="mt-4"
    >
      <DatePicker
        ref="startActivityPeriodRef"
        v-model="item.participant_filters.start_last_online_order"
        class="rounded-lg"
        dense
        label="Дата начала последнего заказа"
        outlined
        :hide-details="true"
        :disabled="isDisabled"
        :clearable="!isDisabled"
      />
      <DatePicker
        ref="startActivityPeriodRef"
        v-model="item.participant_filters.end_last_online_order"
        class="rounded-lg"
        dense
        label="Дата конца последнего заказа"
        outlined
        :hide-details="true"
        :disabled="isDisabled"
        :clearable="!isDisabled"
      />
    </v-row>
    <v-select
      v-model="item.participant_filters.order_pickup_types"
      item-text="label"
      item-value="value"
      :items="$order.pickupTypes"
      class="rounded-lg mr-2 mt-4"
      :clearable="!isDisabled"
      dense
      label="Тип заказа"
      outlined
      multiple
      :return-object="false"
      :disabled="isDisabled"
    ></v-select>
    <v-row
      no-gutters
      class="mt-4"
    >
      <v-col>
        <v-autocomplete
          :key="outletsInputKey"
          small-chips
          :clearable="!isDisabled"
          class="rounded-lg"
          :items="outletsItems"
          item-value="id"
          :item-text="v => v.number + '. ' + v.address"
          v-model="item.participant_filters.outlets"
          label="Торговые точки"
          outlined
          dense
          multiple
          :disabled="isDisabled"
        ></v-autocomplete>
      </v-col>
      <v-btn
        depressed
        color="primary"
        class="ml-3"
        @click="toggleOutletsInFilters()"
        :disabled="isDisabled"
      >
        <div class="text-no">
          {{ item.participant_filters?.outlets?.length ? 'Сбросить' : 'Выбрать все' }}
        </div>
      </v-btn>
    </v-row>

    <v-row
      align="center"
      class="my-0 mt-4"
      no-gutters
    >
      <div
        class="font-weight-medium mr-3"
        style="font-size: 18px"
      >
        Фильтр по зоне на карте
      </div>
      <v-divider />
    </v-row>

    <v-select
      v-model="areaType"
      :items="areaTypeItems"
      item-text="label"
      item-value="value"
      class="rounded-lg mt-2"
      dense
      label="Тип фильтрации"
      outlined
      :clearable="!isDisabled"
      :disabled="isDisabled"
    ></v-select>
    <v-row
      no-gutters
      align="center"
      class="mt-4"
    >
      <v-btn
        depressed
        color="primary"
        @click="openDrawZoneOnMapModal()"
        :disabled="isDisabled"
      >
        <div class="text-none">Указать зону на карте</div>
      </v-btn>
      <div class="ml-3">
        Зоны указаны:
        <b>{{ !!item.participant_filters?.areas?.items.length ? 'Да' : 'Нет' }}</b>
      </div>
    </v-row>
    <OrderItemGroupSelector
      :item="item"
      :group-orders-count="orderItemGroupOrdersCountValue"
      :disabled="isDisabled"
      @update="$emit('refreshForecast')"
    />
    <v-dialog
      v-model="manyPhonesInputModalModelValue"
      max-width="600"
      width="600px"
      @input="onPhoneInputBlur()"
    >
      <v-card class="pa-3">
        <div class="title font-weight-bold">Ввод номеров телефонов</div>
        <div class="text-body-2">Укажите номера телефонов через «;»</div>
        <v-textarea
          v-model="rawPhones"
          rows="1"
          outlined
          class="mt-2"
          height="300px"
        ></v-textarea>

        <v-btn
          color="primary"
          depressed
          class="mt-4"
          width="100%"
          @click="onPhoneInputBlur()"
        >
          <div class="text-none">Подтвердить</div>
        </v-btn>
      </v-card>
    </v-dialog>
    <DrawZoneOnMap
      v-model="drawZoneOnMapModalModelValue"
      :item="item"
    />
  </div>
</template>
<script>
  import DrawZoneOnMap from '@/admin/views/notifications/notificationPage/DrawZoneOnMap.vue'
  import rules from 'air-vue-model/rules'
  import OrderItemGroupSelector from '@/admin/views/notifications/notificationPage/productGroupPicker/OrderItemGroupSelector.vue'
  import { NotificationParticipantFiltersAreaType } from '@/airModels/types/notificationModel'
  import { defineComponent } from 'vue'
  import { cloneDeep } from 'lodash'
  import DatePicker from '@/components/helpers/DatePicker.vue'
  import * as moment from 'moment'

  export default defineComponent({
    name: 'FiltersData',
    components: { DrawZoneOnMap, OrderItemGroupSelector, DatePicker },
    data: () => {
      return {
        outletsInputKey: 0,
        outletsItems: [],
        rawPhones: '',
        validatedPhones: [],
        manyPhonesInputModalModelValue: false,
        orderItemGroupOrdersCountValue: 1,
        drawZoneOnMapModalModelValue: false,
        areaType: NotificationParticipantFiltersAreaType.ARRANGE_PLACE,
        areaTypeItems: [
          {
            label: 'Место оформления',
            value: NotificationParticipantFiltersAreaType.ARRANGE_PLACE
          },
          {
            label: 'Адреса доставки',
            value: NotificationParticipantFiltersAreaType.DELIVERY_ADDRESSES
          }
        ],
        activityPeriodValid: false
      }
    },
    props: {
      item: Object
    },
    emits: ['refreshForecast'],
    methods: {
      onAgeInput(value, field) {
        if (!value) {
          this.item.participant_filters[field] = undefined
        } else {
          const age = Number(value)
          if (age < 0 || Number.isNaN(age)) {
            this.item.participant_filters[field] = undefined
          }
        }
      },
      validatedActivityPerionInputs() {
        this.$refs.startActivityPeriodRef.$refs.textFieldRef.validate()
        this.$refs.endActivityPeriodRef.$refs.textFieldRef.validate()
      },
      onActivityPeriodInput() {
        const filters = this.item?.participant_filters
        if (!filters) {
          this.activityPeriodValid = false
          return this.validatedActivityPerionInputs()
        }
        if (!filters.start_activity_period || !filters.end_activity_period) {
          this.activityPeriodValid = false
          return this.validatedActivityPerionInputs()
        }
        if (!moment(filters.start_activity_period).isBefore(filters.end_activity_period)) {
          this.activityPeriodValid = false
          return this.validatedActivityPerionInputs()
        }
        const daysDiff = moment(filters.end_activity_period).diff(
          filters.start_activity_period,
          'days'
        )

        if (daysDiff > 93) {
          this.activityPeriodValid = false
          return this.validatedActivityPerionInputs()
        }
        this.activityPeriodValid = true
        return this.validatedActivityPerionInputs()
      },
      onPhoneInputBlur() {
        this.manyPhonesInputModalModelValue = false
        const phones = this.rawPhones.split(';')
        const validPhones = new Set()
        for (const rawPhone of phones) {
          let phone = rawPhone.replaceAll(/[ +\-()]/g, '')
          if (phone.startsWith('8')) phone = `7${phone.slice(1, phone.length)}`
          const valid = /[78]?9\d{9}/g.test(phone) && phone.length === 11
          if (valid) validPhones.add(phone)
        }
        this.validatedPhones = [...validPhones]
        if (!this.validatedPhones.length) {
          this.rawPhones = ''
        }
        if (this.validatedPhones.length === 1) this.rawPhones = this.validatedPhones[0]
      },
      openDrawZoneOnMapModal() {
        this.drawZoneOnMapModalModelValue = true
      },
      async setOutlets() {
        let res = []
        if (!this.$outlet.list.length) {
          res = cloneDeep(await this.$outlet.loadList({ page_size: 'all' }))
        } else {
          res = cloneDeep(this.$outlet.list)
        }
        res.forEach(v => (v.disabled = undefined))
        this.outletsItems = res
      },
      toggleOutletsInFilters() {
        if (this.item.participant_filters?.outlets?.length) {
          this.item.participant_filters.outlets = []
        } else {
          this.item.participant_filters.outlets = this.outletsItems.map(v => v.id)
        }
        this.outletsInputKey++
        this.$emit('refreshForecast')
      }
    },
    computed: {
      formattedSelectedPhones() {
        if (!this.rawPhones) return ''
        if (this.validatedPhones.length > 1)
          return `Указано телефонов: ${this.validatedPhones.length}`
        if (this.validatedPhones.length === 1) return this.validatedPhones[0]
        return this.validatedPhones ? this.validatedPhones[0] : ''
      },
      isPhoneInputReadOnly() {
        return this.validatedPhones.length > 1
      },
      rules() {
        return rules
      },
      isDisabled() {
        return !!this.item?.id
      }
    },
    watch: {
      validatedPhones(phones) {
        if (phones.length) this.item.participant_filters.phones = phones
        else this.item.participant_filters.phones = undefined
        this.$emit('refreshForecast')
      },
      areaType(newValue) {
        if (!this.item) return

        if (newValue === null) {
          this.item.participant_filters.areas = undefined
          return
        }

        if (!this.item.participant_filters.areas) {
          this.item.participant_filters.areas = {
            type: newValue,
            items: []
          }
        } else {
          this.item.participant_filters.areas.type = newValue
        }
      },
      item(newValue) {
        if (newValue?.participant_filters?.areas) {
          this.areaType = newValue.participant_filters.areas.type ?? null
        } else {
          this.areaType = null
        }
      }
    },
    mounted() {
      void this.setOutlets()
      if (!this.item) return
      const filters = this.item.participant_filters
      if (!filters) this.item.participant_filters = {}
      if (!this.item?.participant_filters.order_item_groups?.length)
        this.orderItemGroupOrdersCountValue = 1
      else {
        const firstEl = this.item.participant_filters.order_item_groups[0]
        this.orderItemGroupOrdersCountValue = firstEl.orders_count
      }
      if (!filters.start_activity_period || !filters.end_activity_period) {
        filters.start_activity_period = moment.utc().subtract(3, 'month').format('YYYY-MM-DD')
        filters.end_activity_period = moment.utc().format('YYYY-MM-DD')
      }
      if (filters?.phones?.length) {
        this.rawPhones = filters.phones.join(';')
      }
      this.onActivityPeriodInput()
    }
  })
</script>
<style scoped>
  :deep(.v-text-field__details) {
    position: absolute;
    bottom: -20px;
  }

  :deep(.v-textarea .v-input__slot) {
    padding-right: 40px !important;
  }
</style>
